import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { formatDate, formatDateOnlyMonth } from 'react/utils/utils';

function RouteDate({ route }) {
  const { startRoute, finishRoute } = useMemo(() => {
    const {
      actualStart,
      projectedComplete,
      plannedStart,
      plannedComplete
    } = route;

    if (actualStart) {
      const subActualStart = actualStart.substring(0, 10);
      const subProjectComplete = projectedComplete?.substring(0, 10);

      if (projectedComplete && (subActualStart === subProjectComplete)) {
        const actualStartDate = formatDate(actualStart);
        const projectedCompleteDate = formatDate(projectedComplete);

        return {
          startRoute: actualStartDate.substring(11),
          finishRoute: projectedCompleteDate.substring(11)
        };
      }

      return {
        startRoute: formatDateOnlyMonth(actualStart),
        finishRoute: formatDateOnlyMonth(projectedComplete)
      };
    }

    if (plannedStart.substring(0, 10) === plannedComplete.substring(0, 10)) {
      const plannedStartDate = formatDate(plannedStart);
      const plannedCompleteDate = formatDate(plannedComplete);

      return {
        startRoute: plannedStartDate.substring(11),
        finishRoute: plannedCompleteDate.substring(11)
      };
    }

    return {
      startRoute: formatDateOnlyMonth(plannedStart),
      finishRoute: formatDateOnlyMonth(plannedComplete)
    };
  }, [route]);

  const startRouteTooltip = Monet.I18n.getResourcesByKey('routemonitor.routestart');
  const endRouteTooltip = Monet.I18n.getResourcesByKey('routemonitor.routefinish');

  return (
    <div data-testid={`route-${route.key}-dates`} className="routeDate">
      <div className="routeDateStartContainer">
        <div title={startRouteTooltip} data-testid="route-start">{startRoute}</div>
        <div className="startArrow" />
      </div>
      <div className="routeDateEndContainer">
        <div className="endArrow" />
        <div title={endRouteTooltip} data-testid="route-finish">{finishRoute}</div>
      </div>
    </div>
  );
}

RouteDate.propTypes = {
  route: PropTypes.object.isRequired
};

export default RouteDate;
